import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DateSingle from '../selectComponents/DateSingle';;
import HourFilter from '../selectComponents/HourFilter';

const variableChoices = [
  {value: 'temp',   label: 'Temperature'},
  {value: 'wchill', label: 'Wind Chill',},
  {value: 'htindx', label: 'Heat Index',},
  {value: 'dwpt',   label: 'Dewpoint',},
  {value: 'wetb',   label: 'Wet Bulb Temperature',},
  {value: 'rhum',   label: 'Relative Humidity',},
  {value: 'pcpn',   label: 'Precipitation',},
  {value: 'wspd',   label: 'Wind Speed',},
  {value: 'wdir',   label: 'Wind Direction',},
  {value: 'wgust',  label: 'Wind Gust',},
  {value: 'wx',     label: 'Present Weather',},
  {value: 'clds',   label: 'Cloud Conditions',},
  {value: 'vis',    label: 'Visibility',},
  {value: 'pres',   label: 'Station Pressure',},
  {value: 'slp',    label: 'Sea Level Pressure',},
  {value: 'altp',   label: 'Altimeter Setting',},
  {value: 'srad',   label: 'Solar Radiation',},
]

export default function MonhrlyOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton, handleInfoClick } = props;

  return (
    <>
      <Stack direction="column" alignItems="baseline" spacing={1} sx={{ mt: 2 }}>
        <DateSingle 
          userParams={userParams}
          setUserParams={setUserParams}
        />
        <HourFilter 
          userParams={userParams}
          selectOptions={selectOptions}
          handleChange={handleChange}
        />
        <Box sx={{ mt:"0 !important" }}>
          <TextField
            select
            name="variable"
            label="Variable"
            value={userParams.variable}
            onChange={handleChange}
            sx={{ "& .MuiSelect-icon": { right: '7px' } }}
          >
            {selectOptions(variableChoices)}
          </TextField>
        </Box>
      </Stack>
    </>
  )
}